<template>
    <main>
        <div class="row">
            <div class="col-sm-12">
                <div class="alert alert-info">
                    Verique se os colaboradores abaixo ainda estão ativos em sua escola, pois fazem mais de 30 dias desde o último acesso.
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Último Acesso</th>
                                <th>Contratação</th>
                                <th width="50"><i class="fa fa-cogs"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                <td>{{ item.colaborador.nmCompleto }}</td>
                                <td>{{ item.dtUltimoAcesso }}</td>
                                <td>{{ item.dtContratacao }}</td>
                                <td>
                                    <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Inativar" @click="openSituacaoColaboradorEscola(item)">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogSituacaoColaboradorEscola" title="Confirmação de Atualização">
            <strong v-if="model">{{model.colaborador.nmCompleto}}</strong>
            <p>Tem certeza que deseja inativar este colaborador?</p>

            <div slot="modal-footer">
                <button class="btn btn-sm btn-success" @click="atualizaSituacaoColaboradorEscola()">
                    Atualizar
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: 'colaboradordesligamento',
        mixins: [base],
        props: { escolaId: Number, },
        data() {
            return {

                filter: {
                    isPagination: false,
                },

                dialogSituacaoColaboradorEscola: false,

                model: null,

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {

            openSituacaoColaboradorEscola: function (item) {
                this.model = item;
                this.dialogSituacaoColaboradorEscola = true;
            },

            atualizaSituacaoColaboradorEscola: function () {
                this.model.attributeBehavior = "InativaColaboradorEscola";
                new Api('colaboradorescola').post(this.model).then(() => {
                    this.defaultSuccessResult(this.model.colaborador.nmCompleto + " atualizado com sucesso.");
                    this.model = null;
                    this.dialogSituacaoColaboradorEscola = false;
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeLoad: function () {
                this.showLoading();

                this.filter.escolaId = this.escolaId;
                this.filter.somenteSemAcessoRecente = true;
                this.filter.somenteAtivos = true;

                new Api('colaboradorescola').get(this.filter).then(data => {                    
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    //console.log('result', this.result.items);
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeLoad();
        }

    };
</script>